import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

export const FeatureFlag = {
  DriverSession: 'driverSession',
} as const;

export type FeatureFlag = typeof FeatureFlag[keyof typeof FeatureFlag];
export type FeatureFlags = Readonly<Record<FeatureFlag, boolean>>;

export const featureFlags: Readonly<FeatureFlags> = environment.featureFlags;

export function isFeatureEnabled(feature: FeatureFlag): boolean {
  return featureFlags[feature];
}

export function requireFeatureEnabled(feature: FeatureFlag): void {
  if (!isFeatureEnabled(feature)) {
    throw new Error(`Feature "${feature}" is disabled.`);
  }
}

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  isEnabled(feature: FeatureFlag): boolean {
    return isFeatureEnabled(feature);
  }
}
